<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" :showBackButton="false" />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h2 class="purple bold">
          {{ is_re_enroll ? "Rematrícula" : "Matrícula" }}
        </h2>
      </b-col>
    </b-row>

    <div class="sticky-sidebar" ref="stickySidebar">
      <b-col class="sidebar" ref="sidebar">
        <ul>
          <li v-for="(item, index) in stepMenu" :key="`menu-${index + 1}`">
            <button
              :class="
                currentStep == item.id
                  ? 'current'
                  : '' || currentStep > item.id || item.percentage <= percentage
                  ? 'done'
                  : ''
              "
              @click="currentItemAside(item.step_name, item.id)"
              :style="
                item.percentage > percentage || percentage > 70
                  ? 'pointer-events: none; cursor: default;'
                  : ''
              "
            >
              <span>{{ index + 1 }}</span
              ><b>{{ item.name }}</b>
            </button>
          </li>
        </ul>
      </b-col>

      <!-- Form -->
      <b-col class="form-content">
        <form
          class="information content accordion"
          onkeydown="return event.key != 'Enter';"
        >
          <b-row v-if="!loading"> </b-row>
          <div class="loadingView" v-if="loading || changing">
            <LoadingList v-model="loading" text="Carregando dados." />

            <LoadingList v-model="changing" text="Carregando dados." />
          </div>
          <div class="loadingView" v-if="downloadingContract && !loading">
            {{ window.scrollTo({ top: 0, behavior: "smooth" }) }}
            <LoadingList
              v-model="downloadingContract"
              text="Carregando dados."
            />
          </div>
          <div v-if="!changing">
            <!-- Step 1 -->
            <div
              :class="currentStep == 1 ? 'steps current' : 'steps accordion'"
            >
              <StudentData
                v-model="contentForm.StudentData"
                :cycles="objCycles"
                :isReEnroll="is_re_enroll"
                v-if="!loading"
              />
            </div>

            <div :class="currentStep == 2 ? 'steps current' : 'steps'">
              <Contractor
                v-model="contentForm.Contractor"
                :studentAddressId="
                  enrollmentMeta &&
                  enrollmentMeta.EnrollmentStudent &&
                  enrollmentMeta.EnrollmentStudent.address_id
                "
                v-if="!loading"
              />
            </div>

            <div :class="currentStep == 3 ? 'steps current' : 'steps'">
              <Filiation
                v-model="contentForm.Filiation"
                :studentAddressId="
                  enrollmentMeta &&
                  enrollmentMeta.EnrollmentStudent &&
                  enrollmentMeta.EnrollmentStudent.address_id
                "
                v-if="!loading"
              />
            </div>

            <div :class="currentStep == 4 ? 'steps current' : 'steps'">
              <Complementary
                v-model="contentForm.Complementary"
                v-if="!loading"
              />
            </div>

            <div :class="currentStep == 5 ? 'steps current' : 'steps'">
              <Authorizations
                v-model="contentForm.Authorizations"
                :enrollmentMeta="enrollmentMeta"
                v-if="!loading"
              />
            </div>

            <div :class="currentStep == 6 ? 'steps current' : 'steps'">
              <Print
                v-model="contentForm.Print"
                v-if="!loading"
                :formEnroll="contentForm"
              />
            </div>

            <div :class="currentStep == 7 ? 'steps current' : 'steps'">
              <Submit
                v-model="contentForm.Submit"
                v-if="!loading"
                :enrollmentId="this.$route.params.id"
                :enrollmentMeta="enrollmentMeta"
              />
            </div>

            <div class="btn-wrap">
              <b-button
                class="outline"
                :disabled="currentStep == 1 || currentStep == 7 ? true : false"
                @click="prevPage(currentStep)"
                v-show="currentStep != 1"
                type="button"
                >Voltar</b-button
              >
              <b-button
                :class="`${currentStep == maxPage ? 'send-form' : ''}`"
                @click="nextPageConfirm(currentStep)"
                :disabled="!isValid || loading"
                type="button"
              >
                {{
                  currentStep >= maxPage
                    ? "Finalizar"
                    : stepMenu[currentStep - 1].component !== "Print"
                    ? "Salvar e continuar"
                    : rdaUnit === "POUSO_ALEGRE" &&
                      (currentYear === 2022 || currentYear === 2023)
                    ? "Salvar e continuar"
                    : "Gerar Contrato"
                }}
              </b-button>
            </div>
          </div>
        </form>
      </b-col>
      <!-- End Form -->
    </div>
  </b-container>
</template>

<script>
import StudentData from "./form/StudentData.vue";
import Contractor from "./form/Contractor.vue";
import Filiation from "./form/Filiation.vue";
import Complementary from "./form/Complementary.vue";
import Authorizations from "./form/Authorizations.vue";
import Print from "./form/Print.vue";
import Submit from "./form/Submit.vue";
import LoadingList from "@/components/LoadingList.vue";
import DataService from "@/services/enrollments.service.js";
import moment from "moment";
import httpRda from "../../http-rda";
import { mapGetters } from "vuex";
import { extractErrorMessage } from "@/utils/extractErrorMessage";
import { isPousoAlegreUnit } from "@/utils/returnToHomeRules";
import { isPhotoFile } from "@/utils/photo";
import { validateCPF } from "@/utils/validateCPF";
import WaitingListService from "@/services/waitingList.service";
import {
  WAITING_LIST_POPUP_OPTIONS,
  WAITING_LIST_STATUSES,
  waitingListStatusLabel,
} from "@/utils/waitingList";

export default {
  name: "dados-do-aluno",
  components: {
    StudentData,
    Contractor,
    Filiation,
    Complementary,
    Authorizations,
    Print,
    Submit,
    LoadingList,
  },
  data() {
    return {
      is_re_enroll: false,
      objCycles: {},
      waitingList: null,
      changing: false,
      percentage: 0,
      rdaUnit: process.env.VUE_APP_RDA_UNIT,
      currentYear: null,
      currentCycle: null,
      currentStep: 1,
      currentComponent: "StudentData",
      downloadingContract: false,
      maxPage: 7,
      minPage: 1,
      loading: false,
      enrollmentMeta: null,
      stepMenu: [
        {
          id: 1,
          name: "Dados do Aluno",
          step_name: "dados-do-aluno",
          component: "StudentData",
          percentage: 0,
        },
        {
          id: 2,
          name: "Contratantes",
          step_name: "contratantes",
          component: "Contractor",
          percentage: 10,
        },
        {
          id: 3,
          name: "Filiação",
          step_name: "filiacoes",
          component: "Filiation",
          percentage: 30,
        },
        {
          id: 4,
          name: "Complementares",
          step_name: "complementares",
          component: "Complementary",
          percentage: 40,
        },
        {
          id: 5,
          name: "Autorizações",
          step_name: "autorizacao",
          component: "Authorizations",
          percentage: 60,
        },
        {
          id: 6,
          name: "Revisão",
          step_name: "revisao",
          component: "Print",
          percentage: 70,
        },
        {
          id: 7,
          name: "Documentos",
          step_name: "documento",
          component: "Submit",
          percentage: 90,
        },
      ],
      stepMenuOrder: [
        {
          order: 1,
          name: "EnrollmentStudent",
        },
        {
          order: 2,
          name: "EnrollmentResponsibles",
        },
        {
          order: 3,
          name: "EnrollmentResponsibles",
        },
        {
          order: 4,
          name: "EnrollmentComplement",
        },
        {
          order: 5,
          name: "EnrollmentAuthorization",
        },
        {
          order: 6,
          name: "printed_at",
        },
        {
          order: 7,
          name: "EnrollmentFile",
        },
      ],
      breadcrumb: [
        {
          text: "",
          href: null,
          active: true,
        },
      ],
      allContentForm: null,
      contentForm: {
        StudentData: {
          photo: null,
          name: "",
          ethnicity: "",
          birth_date: "",
          guardian: "",
          gender: "",
          skin_color: "",
          lives_with: "",
          previous_school: "",
          phone1: "",
          phone2: "",
          email: "",
          birth_certificate: "",
          cpf: "",
          grade: "",
          segment: "",
          cycle_id: null,
          year_id: null,
          time_period: "",
          hasSiblings: null,
          shouldUpdatePhoto: false,
          EnrollmentStudentBrothers: [],
          Address: {
            id: null,
            cep: null,
            number: null,
            complement: null,
            street: null,
            neighborhood: null,
            city: null,
            state: null,
          },
          pititim_grade_days: {
            manha: [],
            tarde: [],
          },
        },
        Contractor: [
          {
            type: "A",
            relationship: "",
            is_guardian: "",
            is_pedagogical_contact: "",
            is_financial_contact: "",
            is_address_same_student: false,
            photo: null,
            name: this.userName,
            occupation: "",
            workplace: "",
            talents: "",
            phone1: "",
            phone2: "",
            phone_commercial: "",
            email: "",
            allow_email: false,
            cpf: "",
            Address: {
              id: null,
              cep: null,
              number: null,
              complement: null,
              street: null,
              neighborhood: null,
              city: null,
              state: null,
            },
            userCPF: "",
            userName: "",
            userPhone1: "",
            userPhone2: "",
          },
          {
            type: "B",
            relationship: "",
            is_guardian: "",
            is_pedagogical_contact: "",
            is_financial_contact: "",
            is_address_same_student: false,
            photo: null,
            name: this.userName,
            occupation: "",
            workplace: "",
            talents: "",
            phone1: "",
            phone2: "",
            phone_commercial: "",
            email: "",
            allow_email: false,
            cpf: "",
            Address: {
              id: null,
              cep: null,
              number: null,
              complement: null,
              street: null,
              neighborhood: null,
              city: null,
              state: null,
            },
            userCPF: "",
            userName: "",
            userPhone1: "",
            userPhone2: "",
          },
        ],
        Filiation: [],
        Complementary: {
          vaccines_up_to_date: false,
          health_problem: false,
          health_problem_description: "",
          special_accompaniment: false,
          special_accompaniment_description: "",
          special_care: false,
          special_care_description: "",
          medication: false,
          medication_description: "",

          food_restriction: false,
          food_restriction_description: "",
          limitation: false,
          limitation_description: "",
          individual_accompaniment: false,
          individual_accompaniment_description: "",
          healthcare: false,
          healthcare_description: "",

          contact1: "",
          contact1_phone: "",
          contact2: "",
          contact2_phone: "",

          return_to_home: "",

          EnrollmentComplementContacts: [],
        },
        Authorizations: {
          excursion: "",
          leave_school_break: "",
          leave_school_lunch: "",
          leave_school_antecipated: "",
          shower: "",
        },
        Print: {},
        Submit: this.initializeSubmitData(),
      },
    };
  },

  computed: {
    ...mapGetters({
      complement: "enrollment/getComplement",
    }),

    enrollment_id() {
      return this.$route.params.id;
    },

    isPousoAlegre() {
      return isPousoAlegreUnit(this.rdaUnit);
    },

    requiresReturnToHome() {
      return !this.isPousoAlegre;
    },

    watch: {
      contentForm: {
        handler() {
          this.isValid();
        },
        deep: true,
      },
    },
    isValid() {
      function checkAddressFormFields(item) {
        if (
          item.is_address_same_student === "Não" ||
          item.is_address_same_student === false
        ) {
          return (
            item.Address?.cep &&
            item.Address?.cep !== null &&
            item.Address?.number &&
            item.Address?.number !== null &&
            item.Address?.street &&
            item.Address?.street !== null &&
            item.Address?.neighborhood &&
            item.Address?.neighborhood !== null &&
            item.Address?.city &&
            item.Address?.city !== null &&
            item.Address?.state &&
            item.Address?.state !== null
          );
        } else if (
          item.is_address_same_student === "Sim" ||
          item.is_address_same_student === true
        ) {
          return true;
        }
      }

      const formStudentData = this.contentForm.StudentData;
      const formContractor = this.contentForm.Contractor;
      const formFiliation = this.contentForm.Filiation;
      const formComplementary = this.contentForm.Complementary;
      const formAuthorizations = this.contentForm.Authorizations;
      const formSubmit = this.contentForm.Submit;

      const periodsList = ["manha", "tarde"];
      const pititim = formStudentData.pititim_grade_days || {};
      const allDays = periodsList.reduce((acc, p) => {
        const arr = Array.isArray(pititim[p]) ? pititim[p] : [];
        return acc.concat(arr);
      }, []);

      const validPititimForB18 = allDays.length > 0;

      const studentCpfProvided = !!formStudentData.cpf;
      const studentCpfValid =
        studentCpfProvided && validateCPF(formStudentData.cpf);

      const dataValidateStudentData =
        !(formStudentData.name && this.isCompoundName(formStudentData.name)) ||
        !formStudentData.birth_date ||
        !formStudentData.gender ||
        !formStudentData.skin_color ||
        !formStudentData.lives_with ||
        !formStudentData.ethnicity ||
        !formStudentData.guardian ||
        !formStudentData.grade ||
        !formStudentData.Address?.cep ||
        !formStudentData.Address?.state ||
        !formStudentData.Address?.city ||
        !formStudentData.Address?.neighborhood ||
        !formStudentData.Address?.street ||
        !formStudentData.Address?.number ||
        !formStudentData.phone1 ||
        !formStudentData.email ||
        (!formStudentData.birth_certificate && !studentCpfValid) ||
        (studentCpfProvided && !studentCpfValid) ||
        (formStudentData.grade === "B1_8" &&
          (!validPititimForB18 || !formStudentData.year_id)) ||
        (this.is_re_enroll && formStudentData.shouldUpdatePhoto);

      // Contractor
      const dataValidateContractor = formContractor.map((contractor) => {
        const allData =
          !contractor.relationship ||
          !contractor.is_guardian ||
          !contractor.is_pedagogical_contact ||
          !contractor.is_financial_contact ||
          !(contractor.name && this.isCompoundName(contractor.name)) ||
          !contractor.birth_date ||
          !contractor.occupation ||
          !contractor.workplace ||
          !contractor.phone1 ||
          !contractor.email ||
          !contractor.cpf ||
          !validateCPF(contractor.cpf) ||
          !checkAddressFormFields(contractor);

        return allData;
      });

      let dataValidateSubmit = formSubmit;
      if (this.currentYear > 2025) {
        dataValidateSubmit = dataValidateSubmit.map((e) =>
          e?.files.every((item) => item.status === true)
        );
      } else {
        dataValidateSubmit = dataValidateSubmit.map((e) => {
          if (
            e?.files[0].fileName === "vaccination_record" ||
            e?.files[0].fileName === "proof_of_residence"
          ) {
            return true;
          }
          return e?.files.every((item) => item.status === true);
        });
      }
      dataValidateSubmit = dataValidateSubmit.every((cur) => cur === true);

      if (
        !dataValidateSubmit &&
        this.rdaUnit === "POUSO_ALEGRE" &&
        (this.currentYear === 2022 || this.currentYear === 2023)
      ) {
        dataValidateSubmit = true;
      }

      const dataValidateComplementaryAux =
        !formComplementary.contact1 ||
        !formComplementary.contact1_phone ||
        formComplementary.contact1_phone.length !== 15 ||
        !formComplementary.contact2 ||
        !formComplementary.contact2_phone ||
        formComplementary.contact2_phone.length !== 15 ||
        (this.requiresReturnToHome && !formComplementary.return_to_home) ||
        (formComplementary.food_restriction &&
          !formComplementary.food_restriction_description) ||
        (formComplementary.health_problem &&
          !formComplementary.health_problem_description) ||
        (formComplementary.healthcare &&
          !formComplementary.healthcare_description) ||
        (formComplementary.limitation &&
          !formComplementary.limitation_description) ||
        (formComplementary.special_accompaniment &&
          !formComplementary.special_accompaniment_description) ||
        (formComplementary.special_care &&
          !formComplementary.special_care_description);

      let validateContacts = true;

      if (formComplementary.return_to_home === "Acompanhado") {
        const contacts = formComplementary.EnrollmentComplementContacts || [];

        if (this.isPousoAlegre && contacts.length === 0) {
          validateContacts = false;
        } else {
          for (const item of contacts) {
            if (!item.name || !item.number1 || !item.relationship) {
              validateContacts = false;
              break;
            }
          }
        }
      }

      const dataValidateComplementary =
        validateContacts && !dataValidateComplementaryAux ? null : true;

      // Authorizations
      let dataValidateAuthorizations = Object.values(formAuthorizations);
      dataValidateAuthorizations = dataValidateAuthorizations.every(
        (e) => e !== "" && e !== null && e !== undefined
      );

      //Filiation
      const dataValidateFiliation =
        formFiliation.length === 2
          ? formFiliation.map((item) => {
              if (item.previousInformed == null) {
                return false;
              }

              switch (item.previousInformed) {
                case "Sim":
                case true:
                  return item.formData !== null &&
                    item.formData.id !== undefined
                    ? false
                    : true;
                case "Não":
                case false:
                  if (item.deceased && !item.not_applicable) {
                    const hasRelationship = !!item.formData.relationship;
                    const hasFullName = !!(
                      item.formData.name &&
                      this.isCompoundName(item.formData.name)
                    );

                    return !hasRelationship || !hasFullName;
                  } else if (!item.deceased && item.not_applicable) {
                    return !item.formData.name == "Não há";
                  } else {
                    const hasGuardian = !!item.formData.is_guardian;
                    const hasRelationship = !!item.formData.relationship;
                    const hasFullName = !!(
                      item.formData.name &&
                      this.isCompoundName(item.formData.name)
                    );
                    const hasOccupation = !!item.formData.occupation;
                    const hasWorkplace = !!item.formData.workplace;
                    const hasEmail = !!item.formData.email;
                    const hasCpf =
                      !!item.formData.cpf && validateCPF(item.formData.cpf);
                    const hasPhone1 = !!item.formData.phone1;
                    const hasValidAddress = !!checkAddressFormFields(
                      item.formData
                    );

                    return (
                      !hasGuardian ||
                      !hasRelationship ||
                      !hasFullName ||
                      !hasOccupation ||
                      !hasWorkplace ||
                      !hasEmail ||
                      !hasCpf ||
                      !hasPhone1 ||
                      !hasValidAddress
                    );
                  }
                default:
                  break;
              }
            })
          : false;

      // condictions
      switch (this.currentComponent) {
        case "StudentData":
          return dataValidateStudentData ? false : true;
        case "Contractor":
          return dataValidateContractor.every((cur) => cur !== true);

        case "Complementary":
          return dataValidateComplementary ? false : true;

        case "Authorizations":
          return dataValidateAuthorizations ? true : false;

        case "Print":
          return true;

        case "Submit":
          if (dataValidateSubmit) {
            httpRda.patch(`/enrollments/${this.enrollment_id}/setReenroll`, {
              enrollment_file: dataValidateSubmit,
            });
          }
          return dataValidateSubmit ? true : false;
        case "Filiation":
          return dataValidateFiliation === false
            ? false
            : dataValidateFiliation.every((cur) => cur !== true);
        default:
          return null;
      }
    },
  },

  methods: {
    createFileObject(fileName) {
      return {
        file: null,
        progress: null,
        status: false,
        fileName,
        url: "",
        notApplicable: false,
      };
    },

    createSubmitItem(title, isRequired, fileNames) {
      return {
        title,
        isRequired,
        files: fileNames.map((fileName) => this.createFileObject(fileName)),
      };
    },

    initializeSubmitData() {
      const documents = [
        {
          title: "Carteira de identidade do aluno (Frente e Verso)",
          isRequired: true,
          files: ["identity", "identity_back"],
        },
        {
          title: "CPF do aluno",
          isRequired: true,
          files: ["cpf"],
        },
        {
          title: "Cartão de vacinas do aluno",
          isRequired: true,
          files: ["vaccination_record"],
        },
        {
          title: "Declaração de transferência",
          isRequired: true,
          files: ["transference_declaration"],
        },
        {
          title: "Declaração de quitação emitida pela escola anterior",
          isRequired: true,
          files: ["discharge"],
        },
        {
          title: "Histórico Escolar/ Registro de Percurso (Educação Infantil)",
          isRequired: true,
          files: ["school_record"],
        },
        {
          title: "Carteira de identidade do contratante A (Frente e Verso)",
          isRequired: true,
          files: ["identity_contractor_a", "identity_contractor_a_back"],
        },
        {
          title: "Carteira de identidade do contratante B (Frente e Verso)",
          isRequired: true,
          files: ["identity_contractor_b", "identity_contractor_b_back"],
        },
        {
          title: "CPF dos contratantes",
          isRequired: true,
          files: ["cpf_contractor_a", "cpf_contractor_b"],
        },
        {
          title: "Comprovante de residência",
          isRequired: true,
          files: ["proof_of_residence"],
        },
      ];

      return documents.map((doc) =>
        this.createSubmitItem(doc.title, doc.isRequired, doc.files)
      );
    },

    fixBirthDate(originDate) {
      if (!originDate || typeof originDate !== "string" || !originDate.trim()) {
        throw new Error("Data de nascimento é obrigatória. Preencha o campo corretamente.");
      }

      const cleaned = originDate.replace(/[_]/g, "").trim();
      if (cleaned.length === 0) {
        throw new Error("Data de nascimento não foi preenchida. Preencha o campo corretamente.");
      }

      const auxDate = moment(cleaned, "DD/MM/YYYY", true);

      if (!auxDate.isValid()) {
        throw new Error(
          `Data de nascimento inválida: "${originDate}". Preencha uma data válida no formato DD/MM/AAAA.`
        );
      }

      return auxDate.toISOString();
    },

    isCompoundName(name) {
      name = name.trim();
      const nameArr = name.split(" ");

      if (nameArr.length >= 2) {
        return true;
      } else {
        return false;
      }
    },

    async getGrades() {
      await httpRda.get("v2/cycles-to-enrollment").then((resp) => {
        this.objCycles = resp.data.cycles;
      });
    },

    setStudentGrade(grade, turn, year_id) {
      if (grade === "B1_8") {
        return {
          cycle_id: 8,
          year_id: year_id ? year_id : 1,
        };
      }

      if ((grade, turn)) {
        for (const cycles in this.objCycles) {
          if (this.objCycles[cycles] && Array.isArray(this.objCycles[cycles])) {
            for (const g of this.objCycles[cycles]) {
              if (
                g.grade === grade &&
                g.time_period &&
                g.time_period === turn.toLowerCase()
              ) {
                return {
                  cycle_id: g.cycle_id,
                  year_id: g.year_id,
                };
              }
            }
          }
        }

        return null;
      }
    },

    // Step
    async currentItemAside(step, id) {
      if (id > 1 && (await this.stopOnWaitingList())) {
        return;
      }

      this.loading = true;
      this.$router
        .replace({
          params: { step: step },
        })
        .catch(() => {});
      this.currentStep = id;

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // Form
      await this.createUpdateEnrollment();
      this.getEnrollmentPercentage();
      this.loading = false;
    },

    async nextPageConfirm(current) {
      this.changing = true;
      if (this.is_re_enroll && current >= 1 && current < 6) {
        this.$swal
          .fire({
            title: "Confirmação de dados",
            text: "Todos os dados foram conferidos e atualizados? Assegure-se de ter utilizado uma foto atualizada quando for necessário.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#68c5b7",
            cancelButtonColor: "#d33",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              try {
                await this.nextPage(current);
              } catch (error) {
                this.$swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: extractErrorMessage(error.response.data?.message),
                  footer: "Por favor, tente novamente mais tarde.",
                });

                return error.response;
              }
            } else {
              this.changing = false;
              return;
            }
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: extractErrorMessage(error.response.data?.message),
              footer: "Por favor, tente novamente mais tarde.",
            });

            return error.response;
          });
      } else {
        try {
          await this.nextPage(current);
        } catch (error) {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: extractErrorMessage(error.response.data?.message),
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error.response;
        }
      }
    },

    async nextPage(current) {
      let submitType = "";

      let currentId = parseInt(current);
      let currentPageItem = null;
      try {
        this.loading = true;
        submitType = "update";

        this.getEnrollmentPercentage();
        switch (this.stepMenu[currentId - 1].component) {
          case "StudentData":
            await this.studentDataForm(submitType);

            if (await this.stopOnWaitingList()) {
              this.loading = false;
              this.changing = false;
              return;
            }
            break;

          case "Contractor":
            await this.contractorDataForm(submitType);
            break;
          case "Filiation":
            await this.filiationDataForm(submitType);
            break;

          case "Complementary":
            await this.createUpdateComplement(submitType);
            break;

          case "Authorizations":
            await this.createUpdateAuthorizations(submitType);
            break;

          case "Print":
            await this.getPrintData(submitType);
            break;

          case "Submit":
            this.$router.push({ path: "/matriculas" });
            break;
          default:
            break;
        }

        if (currentId < this.maxPage) {
          currentId += 1;
          this.currentStep = currentId;
        }

        currentPageItem = this.stepMenu[this.currentStep - 1].step_name;
        await this.currentItemAside(currentPageItem, currentId);
        this.changing = false;
      } catch (error) {
        this.loading = false;
        this.changing = false;
        this.downloadingContract = false;

        if (!error.message.includes("step_name")) {
          this.$swal.fire({
            icon: "error",
            title: "Ops...",
            text: error.message,
          });
        }
      }
    },

    async prevPage(current) {
      let currentId = parseInt(current);
      let currentPageItem = null;

      this.loading = true;

      if (currentId > this.minPage) {
        currentId -= 1;
        this.currentStep = currentId;
      }

      currentPageItem = this.stepMenu[this.currentStep - 1].step_name;
      await this.currentItemAside(currentPageItem, currentId);
    },

    async studentDataForm(type) {
      const { ...student } = this.contentForm.StudentData;
      let studentPhoto = null;
      const enrollment_id = this.$route.params.id;
      const gradeData = this.setStudentGrade(
        student.grade,
        student.time_period?.toLowerCase(),
        student.year_id
      );

      switch (type) {
        case "update":
        case "post":
          if (!gradeData) {
            this.contentForm.StudentData.grade = null;
            this.contentForm.StudentData.time_period = null;
            throw new Error(
              "Segmento ou turno inválido. Selecione uma opção válida e tente novamente."
            );
          }

          if (student.shouldUpdatePhoto) {
            studentPhoto = student.photo;
            student.photo = undefined;
            throw new Error("É necessário atualizar a foto do aluno.");
          }

          this.fixBirthDate(this.contentForm.StudentData.birth_date);

          student.is_re_enroll = this.is_re_enroll;
          studentPhoto = student.photo;
          student.photo = undefined;
          student.cycle_id = gradeData.cycle_id;
          student.year_id = gradeData.year_id;
          student.birth_date = this.fixBirthDate(
            this.contentForm.StudentData.birth_date
          );
          student.cpf = student.cpf?.replace(/[^\w\s]/gi, "");
          this.downloadingContract = true;

          await httpRda
            .patch(`/enrollments/${enrollment_id}/students`, student)
            .then(async (response) => {
              this.waitingList = response.data.waiting_list;

              if (typeof studentPhoto !== "string") {
                await httpRda
                  .patch(
                    `/enrollments/${enrollment_id}/students`,
                    studentPhoto,
                    {
                      headers: { "Content-Type": "multipart/form-data" },
                    }
                  )
                  .catch((error) => {
                    throw new Error(extractErrorMessage(error.response.data?.details));
                  });
              }

              await httpRda.patch(`/enrollments/${enrollment_id}/setReenroll`, {
                enrollment_student: this.is_re_enroll,
              });
            })
            .catch((error) => {
              this.downloadingContract = false;
              this.contentForm.StudentData.photo = studentPhoto;
              throw new Error(extractErrorMessage(error.response.data?.details));
            });

          this.downloadingContract = false;
          break;
        default:
          this.loading = true;
          await DataService.getEnrollmentStudent(
            enrollment_id,
            this.contentForm.StudentData
          )
            .then((response) => {
              this.loading = false;
              this.contentForm.StudentData = response.data.enrollmentStudent;
              this.contentForm.StudentData.Address = this.contentForm
                .StudentData.Address || {
                id: null,
                cep: null,
                number: null,
                complement: null,
                street: null,
                neighborhood: null,
                city: null,
                state: null,
              };
              const studentBirthDate = moment(
                this.contentForm.StudentData.birth_date
              );

              this.contentForm.StudentData.birth_date = studentBirthDate.isValid()
                ? studentBirthDate.format("DD/MM/YYYY")
                : "";

              this.$set(
                this.contentForm.StudentData,
                "shouldUpdatePhoto",
                this.is_re_enroll ||
                  this.contentForm.StudentData.calendar_id !=
                    this.contentForm.StudentData.photo_calendar_id
              );
              this.contentForm.StudentData.pititim_grade_days = response.data
                .EnrollmentPititims
                ? { ...response.data.pititim_grade_days }
                : { manha: [], tarde: [] };
            })
            .catch((error) => {
              this.loading = false;
              throw new Error(extractErrorMessage(error.response.data?.message));
            });
          this.loading = false;
          break;
      }
    },

    async contractorDataForm(type) {
      const enrollment_id = this.$route.params.id;
      const contractors = this.contentForm.Contractor;
      let arrContractors = [];

      switch (type) {
        case "update":
        case "post":
          for (const contractor of contractors) {
            this.fixBirthDate(contractor.birth_date);
          }

          for (const contractor of contractors) {
            if (contractor.photo instanceof FormData) {
              arrContractors.push({
                photo: contractor.photo,
                id: contractor.id || null,
                email: contractor.email,
              });
              contractor.photo = undefined;
            }
            contractor.is_re_enroll = this.is_re_enroll;

            contractor.birth_date = this.fixBirthDate(contractor.birth_date);
          }

          try {
            const resp = await httpRda.patch(
              `/enrollments/${enrollment_id}/contractor`,
              { contractor: contractors }
            );

            for (const responsible of resp.data.contractors) {
              const index = arrContractors.findIndex(
                (contractor) =>
                  contractor.id == null && contractor.email == responsible.email
              );
              if (index != -1) {
                arrContractors[index].id = responsible.id;
              }
            }

            if (arrContractors.length > 0) {
              for (const contractor of arrContractors) {
                if (contractor.id == null) {
                  throw new Error(
                    "Não foi possível associar a foto do contratante ao responsável correspondente."
                  );
                }

                await httpRda.patch(
                  `/enrollments/${enrollment_id}/responsible/${contractor.id}`,
                  contractor.photo,
                  {
                    headers: { "Content-Type": "multipart/form-data" },
                  }
                );
              }
            }

            await httpRda.patch(
              `/enrollments/${this.enrollment_id}/setReenroll`,
              { enrollment_responsibles_contractors: this.is_re_enroll }
            );
          } catch (error) {
            for (const arrContractor of arrContractors) {
              const contractor = contractors.find(
                (item) => item?.email === arrContractor.email
              );
              if (contractor) {
                contractor.photo = arrContractor.photo;
              }
            }

            throw new Error(
              error.response
                ? extractErrorMessage(error.response.data?.msg)
                : error.message
            );
          }
          break;
        default:
          await httpRda
            .get(`/enrollments/${enrollment_id}/responsibles`)
            .then((response) => {
              this.contentForm.Contractor = response.data.responsibles
                .filter((responsible) =>
                  responsible.ResponsibleTypes[0].type.includes("contractor")
                )
                .map((responsible) => {
                  const birthDate = moment(responsible.birth_date);

                  responsible.birth_date = birthDate.isValid()
                    ? birthDate.format("DD/MM/YYYY")
                    : "";

                  return responsible;
                });
            })
            .catch((error) => {
              throw new Error(extractErrorMessage(error.response.data?.msg));
            });
          break;
      }
    },

    async filiationDataForm(type) {
      const enrollment_id = this.$route.params.id;
      let filiates = this.contentForm.Filiation;
      let previousInformedAux;
      let arrFiliates = [];

      filiates = filiates.map((filiate) => {
        if (filiate.type != undefined) {
          return {
            ...filiate,
            type: `filiation ${filiate.type
              .substring(filiate.type.length - 1)
              .toLocaleLowerCase()}`.toLocaleLowerCase(),
            is_re_enroll: this.is_re_enroll,
          };
        }
      });

      switch (type) {
        case "update":
        case "post":
          if (
            filiates.some(
              (filiate) =>
                filiate.formData.shouldUpdatePhoto &&
                !filiate.not_applicable &&
                !filiate.deceased
            )
          ) {
            throw new Error("É necessário atualizar as fotos das filiações.");
          }

          for (const filiate of filiates) {
            if (filiate.formData.photo instanceof FormData) {
              arrFiliates.push({
                photo: filiate.formData.photo,
                id: filiate.formData.id || null,
                email: filiate.formData.email,
              });
              filiate.formData.photo = undefined;
            }
          }

          try {
            const response = await httpRda.patch(
              `/enrollments/${enrollment_id}/filiation`,
              { filiate: filiates }
            );

            for (const formData of response.data.result) {
              const index = arrFiliates.findIndex(
                (filiateArr) =>
                  filiateArr.id == null &&
                  filiateArr.email == formData.filiate.email
              );
              if (index != -1) {
                arrFiliates[index].id = formData.filiate.id;
              }
            }

            if (arrFiliates.length > 0) {
              for (const filiate of arrFiliates) {
                if (filiate.id == null) {
                  throw new Error(
                    "Não foi possível associar a foto da filiação ao responsável correspondente."
                  );
                }

                await httpRda.patch(
                  `/enrollments/${enrollment_id}/responsible/${filiate.id}`,
                  filiate.photo,
                  {
                    headers: { "Content-Type": "multipart/form-data" },
                  }
                );
              }
            }

            await httpRda.patch(
              `/enrollments/${this.enrollment_id}/setReenroll`,
              { enrollment_responsibles_filiations: this.is_re_enroll }
            );
          } catch (error) {
            for (const arrFiliate of arrFiliates) {
              const filiate = filiates.find(
                (item) => item?.formData?.email === arrFiliate.email
              );
              if (filiate) {
                filiate.formData.photo = arrFiliate.photo;
              }
            }

            throw new Error(
              error.response
                ? extractErrorMessage(error.response.data?.details)
                : error.message
            );
          }
          break;
        default:
          await httpRda
            .get(`/enrollments/${enrollment_id}/responsibles`)
            .then((response) => {
              this.contentForm.Filiation = [];
              for (const responsible of response.data.responsibles) {
                responsible.ResponsibleTypes.length > 1
                  ? (previousInformedAux = "Sim")
                  : (previousInformedAux = "Não");
                for (const types of responsible.ResponsibleTypes) {
                  if (types.type.includes("filiation")) {
                    this.contentForm.Filiation.push({
                      previousInformed: previousInformedAux,
                      formData: responsible,
                      not_applicable: null,
                      deceased: null,
                    });
                  }
                }
              }
            })
            .catch((error) => {
              throw new Error(extractErrorMessage(error.response.data?.msg));
            });

          break;
      }
    },

    async createUpdateAuthorizations(type) {
      const enrollment_id = this.$route.params.id;
      const { Authorizations } = this.contentForm;

      Authorizations.is_re_enroll = this.is_re_enroll;

      switch (type) {
        case "update":
        case "post":
          await httpRda
            .post(`/enrollments/${enrollment_id}/authorization`, Authorizations)
            .then(async () => {
              await httpRda.patch(
                `/enrollments/${this.enrollment_id}/setReenroll`,
                { enrollment_authorization: this.is_re_enroll }
              );
            })
            .catch((error) => {
              throw new Error(extractErrorMessage(error.response.data?.details));
            });
          break;
        default:
          await httpRda
            .get(`/enrollments/${enrollment_id}/authorization`)
            .then((response) => {
              this.contentForm.Authorizations =
                response.data.authorization !== null
                  ? {
                      ...response.data.authorization,
                      cycle_id: response.data.enrollment.cycle_id,
                    }
                  : {
                    ...this.contentForm.Authorizations,
                    cycle_id: response.data.enrollment.cycle_id,
                  };
            });

          break;
      }
    },

    async createUpdateComplement(type) {
      const enrollment_id = this.$route.params.id;
      const complemantary = this.contentForm.Complementary;
      complemantary.is_re_enroll = this.is_re_enroll;

      if (
        complemantary.return_to_home !== "Sozinho" &&
        complemantary.EnrollmentComplementContacts.some(
          (contact) => contact.shouldUpdatePhoto
        )
      ) {
        throw new Error(
          "É necessário atualizar as fotos de todos os contatos autorizados."
        );
      }

      switch (type) {
        case "update":
        case "post":
          await httpRda
            .patch(`/enrollments/${enrollment_id}/complement`, {
              complement: complemantary,
              id: enrollment_id,
            })
            .then(async () => {
              await httpRda.patch(
                `/enrollments/${this.enrollment_id}/setReenroll`,
                { enrollment_complement: this.is_re_enroll }
              );
            })
            .catch((error) => {
              throw new Error(extractErrorMessage(error.response.data?.msg));
            });
          await this.createUpdateContacts(enrollment_id);
          break;

        default:
          await httpRda
            .get(`/enrollments/${enrollment_id}/complement`)
            .then((response) => {
              const data = response.data.enrollment_complement;
              this.contentForm.Complementary = data ? { ...data } : { ...this.contentForm.Complementary }

            });

          break;
      }
    },

    async getPrintData(type) {
      const enrollment_id = this.$route.params.id;

      switch (type) {
        case "update":
        case "post":
          this.loading = true;
          this.downloadingContract = true;
          await httpRda
            .post(`/enrollments/${enrollment_id}/finish`)
            .then(async () => {
              await httpRda
                .patch(`/enrollments/${enrollment_id}`, {
                  enrollment_id: enrollment_id,
                  is_printed: true,
                })
                .then(async () => {
                  let downloadContract = true;

                  if (
                    this.rdaUnit === "POUSO_ALEGRE" &&
                    (this.currentYear === 2022 || this.currentYear === 2023)
                  ) {
                    downloadContract = false;
                  }

                  await httpRda.patch(
                    `/enrollments/${this.enrollment_id}/setReenroll`,
                    { printed_at: this.is_re_enroll }
                  );

                  if (downloadContract) {
                    await httpRda.get(
                      `/enrollments/${enrollment_id}/contract/download`
                    );
                    await this.getEnrollmentMeta(enrollment_id);
                  }
                  this.downloadingContract = false;
                });
            })
            .catch((error) => {
              this.downloadingContract = false;
              throw new Error(extractErrorMessage(error.response.data?.error));
            });
          break;

        default:
          this.loading = true;
          await httpRda
            .get(`/enrollments-opt/${enrollment_id}/print`)
            .then(async (response) => {
              let contractors = [];
              let filiations = [];
              this.currentCycle =
                response.data &&
                response.data.enrollment &&
                response.data.enrollment.EnrollmentStudent &&
                response.data.enrollment.EnrollmentStudent.cycle_id;

              for (const responsible of response.data.enrollment
                .EnrollmentResponsibles) {
                for (const types of responsible.ResponsibleTypes) {
                  if (types.type.includes("contractor")) {
                    contractors.push({
                      ...responsible,
                      type: types.type
                        .replace("contractor", "Contratante")
                        .replace(
                          /\w\S*/g,
                          (m) =>
                            m.charAt(0).toUpperCase() +
                            m.substr(1).toLowerCase()
                        ),
                    });
                  } else if (types.type.includes("filiation")) {
                    filiations.push({
                      ...responsible,
                      type: types.type
                        .replace("filiation", "Filiacão")
                        .replace(
                          /\w\S*/g,
                          (m) =>
                            m.charAt(0).toUpperCase() +
                            m.substr(1).toLowerCase()
                        ),
                    });
                  }
                }
              }

              let gradeName;
              const enrollmentId =
                response.data &&
                response.data.enrollment &&
                response.data.enrollment.id
                  ? response.data.enrollment.id
                  : null;
              const isReenroll =
                response.data.enrollment.EnrollmentStudent.is_re_enroll;

              if (enrollmentId) {
                const gradeResponse = await httpRda.get("/cycle-grades", {
                  params: {
                    enrollment_id: enrollmentId,
                  },
                });

                const data =
                  gradeResponse.data && gradeResponse.data.result
                    ? gradeResponse.data.result
                    : null;

                if (data) {
                  gradeName = isReenroll
                    ? data.reenrollment_description
                    : data.enrollment_description;
                }
              }

              this.contentForm.Print = {
                ...response.data.enrollment,
                gradeName,
                Contractor: contractors.sort((a, b) => {
                  if (a.type < b.type) {
                    return -1;
                  }
                  if (a.type > b.type) {
                    return 1;
                  }
                  return 0;
                }),
                Filiation: filiations.sort((a, b) => {
                  if (a.type < b.type) {
                    return -1;
                  }
                  if (a.type > b.type) {
                    return 1;
                  }
                  return 0;
                }),
              };
              this.loading = false;
            });
          this.loading = false;
          break;
      }
    },

    async createUpdateContacts(id) {
      if (this.contentForm.Complementary.return_to_home !== "Sozinho") {
        for (const contact of this.contentForm.Complementary
          .EnrollmentComplementContacts) {
          if (contact.shouldUpdatePhoto) {
            contact.photo = undefined;
            throw new Error(
              "É necessário atualizar a foto de um dos contatos para saída."
            );
          }
        }

        const toUpdate =
          this.contentForm.Complementary.EnrollmentComplementContacts.filter(
            (contact) => contact.id !== undefined
          );

        const toCreate =
          this.contentForm.Complementary.EnrollmentComplementContacts.filter(
            (contact) => contact.id === undefined
          );

        if (toUpdate.length) {
          for (const { photo, ...contact } of toUpdate) {
            await httpRda.patch(
              `/enrollments/${id}/contacts/${contact.id}`,
              contact
            );

            if (isPhotoFile(photo)) {
              const bodyFormData = new FormData();
              bodyFormData.append("file", photo);

              await httpRda.patch(
                `enrollments/${id}/contacts/${contact.id}`,
                bodyFormData,
                {
                  headers: { "Content-Type": "multipart/form-data" },
                }
              );
            }
          }
        }

        if (toCreate.length) {
          for (const { photo, ...contact } of toCreate) {
            const response = await httpRda.post(
              `/enrollments/${id}/contacts`,
              contact
            );

            if (isPhotoFile(photo)) {
              const createdId = response.data.complement.find(
                (c) => c.name === contact.name
              ).id;

              const bodyFormData = new FormData();
              bodyFormData.append("file", photo);

              await httpRda.patch(
                `enrollments/${id}/contacts/${createdId}`,
                bodyFormData,
                {
                  headers: { "Content-Type": "multipart/form-data" },
                }
              );
            }
          }
        }
      }
    },

    async createUpdateEnrollment() {
      this.currentComponent = this.stepMenu[this.currentStep - 1].component;

      switch (this.currentComponent) {
        case "StudentData":
          await this.studentDataForm();
          break;

        case "Contractor":
          await this.contractorDataForm();
          break;

        case "Filiation":
          await this.filiationDataForm();
          break;

        case "Complementary":
          await this.createUpdateComplement();
          break;

        case "Authorizations":
          await this.createUpdateAuthorizations();
          break;

        case "Print":
          await this.getPrintData();
          break;

        default:
          null;
      }
    },

    checkObject(key, obj) {
      switch (key) {
        case "EnrollmentFinance":
        case "signed_at":
          return true;
        case "EnrollmentStudent":
          obj[key] === null ? false : true;
          break;
        case "EnrollmentResponsibles":
          obj[key].some((e) => e.ResponsibleTypes);
          break;
        default:
          break;
      }
    },

    async getEnrollmentYear() {
      this.currentYear = await httpRda
        .get(`/enrollment/${this.$route.params.id}/year`)
        .then((response) => response.data.year);
    },

    async getEnrollmentPercentage() {
      this.percentage = await httpRda
        .get(`/enrollments/${this.$route.params.id}/percentage`)
        .then((response) => response.data.percentage);
    },

    async getWaitingList() {
      this.waitingList = await WaitingListService.getByEnrollment(
        this.$route.params.id
      ).then((response) => response.data.waiting_list);
    },

    async askWaitingList() {
      const result = await this.$swal.fire({
        ...WAITING_LIST_POPUP_OPTIONS,
        title: "Vagas indisponíveis",
        text: "Estamos sem vagas para o Ciclo escolhido! Deseja entrar na lista de espera?",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonColor: "#68c5b7",
        cancelButtonColor: "#d33",
        confirmButtonText: "Entrar na lista de espera",
        cancelButtonText: "Não entrar",
      });
      const accepted = result.isConfirmed;

      this.waitingList = await WaitingListService.respond(
        this.$route.params.id,
        accepted
      ).then((response) => response.data.waiting_list);

      await this.$swal.fire({
        ...WAITING_LIST_POPUP_OPTIONS,
        icon: accepted ? "success" : "info",
        title: accepted
          ? "Aluno incluído na lista de espera"
          : "Matrícula pausada",
        text: accepted
          ? 'Acompanhe o status na aba "Matrículas". O preenchimento do Requerimento poderá ser reiniciado quando houver liberação de vaga pela coordenação.'
          : "O procedimento de matrícula não poderá continuar enquanto o ciclo estiver indisponível. Você pode alterá-lo nos dados do aluno, caso tenha preenchido de forma equivocada.",
      });
    },

    async stopOnWaitingList() {
      if (!this.waitingList) {
        await this.getWaitingList();
      }

      if (!this.waitingList || !this.waitingList.blocked) {
        return false;
      }

      if (
        !this.waitingList.status ||
        this.waitingList.status === WAITING_LIST_STATUSES.DECLINED
      ) {
        await this.askWaitingList();
      } else {
        await this.$swal.fire({
          ...WAITING_LIST_POPUP_OPTIONS,
          icon: "info",
          title: waitingListStatusLabel(this.waitingList.status),
          text: "A matrícula não pode continuar enquanto a vaga não for liberada pela coordenação.",
        });
      }

      this.$router.push({ name: "matriculas" });

      return true;
    },

    async getEnrollmentMeta(enrollmentId = this.$route.params.id) {
      this.enrollmentMeta = await httpRda
        .get(`/enrollments-opt/${enrollmentId}/meta`)
        .then((response) => response.data.enrollment);
    },
  },

  async created() {
    this.getGrades();
    this.getEnrollmentMeta();
    this.$route.name.includes("rematricula")
      ? (this.is_re_enroll = true)
      : (this.is_re_enroll = false);

    if (this.$router.currentRoute) {
      this.currentStep = this.$route.params.step;

      const cur = this.stepMenu.find((item) => item.step_name == this.currentStep);
      if (cur) {
        await this.currentItemAside(this.currentStep, cur.id);
      }

      // Set currentComponent
      this.currentComponent = this.stepMenu[this.currentStep - 1].component;
    }

    this.getEnrollmentYear();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

.container-rda {
  max-width: 1600px;
  margin: 0 auto;
}

.sticky-sidebar {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
  position: relative;
  box-sizing: border-box;

  .sidebar {
    flex: 0 0 250px;
    padding: 0;
    position: -webkit-sticky;
    position: sticky;
    top: 0px;
    padding-top: 50px;

    ul {
      margin: 0;
      padding: 0;

      li {
        width: 100%;
        list-style: none;

        button {
          background: transparent;
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 15px;
          border: 0;
          opacity: 0.5;
          transition: 0.1s all ease-in-out;

          &.click {
            pointer-events: none;
            cursor: default;
          }

          &:hover {
            opacity: 1;
            transition: 0.2s all ease-in-out;
          }

          &.current {
            opacity: 1;
            transition: 0.2s all ease-in-out;
            pointer-events: all;
            cursor: pointer;

            span {
              color: $white;
              background: $purple;
              transition: 0.2s all ease-in-out;
            }
          }

          &.done {
            opacity: 1;
            transition: 0.2s all ease-in-out;
            pointer-events: all;
            cursor: pointer;

            span {
              color: $white;
              background: $green;
              transition: 0.2s all ease-in-out;
            }
          }

          span {
            font-weight: 700;
            font-size: 14px;
            line-height: 17px;
            color: #b3b3b3;
            background: $gray;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50px;
          }

          b {
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 24px;
            color: #1a1a1a;
          }
        }
      }
    }
  }
  .content {
    box-sizing: border-box;
    padding-top: 50px;

    .steps {
      display: none;

      &.current {
        display: block;
      }
    }
  }
}

.btn-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 50px;

  button {
    min-width: 150px;

    &.send-form {
      color: $white !important;
      background: $gradient1;
      border-color: transparent;

      &:hover,
      &:focus,
      &:active {
        border-color: transparent !important;
      }
    }
  }
}

.loadingView {
  width: 100%;
  height: 200px;
  position: relative;

  .loading {
    width: 100%;
    display: flex !important;
    align-items: center;
    justify-content: center;

    div {
      text-align: center;
      background: transparent;
      max-width: 158px !important;
      line-height: 15px;
      border: 0;
      display: flex !important;
      flex-direction: column;
      row-gap: 10px;
      box-shadow: none;
      transform: translateX(0px);
    }
  }
}

.form-content {
  [id*="accordion-"] {
    border-bottom: 1px solid #b3b3b3;
    padding-bottom: 30px;
  }
  .form-group {
    margin-bottom: 20px !important;

    label {
      font-size: 0.8rem;
    }
  }
  .photo-picture {
    border-radius: 6px;

    .photoImg {
      background: #cecece;
      width: 100%;
      padding: 5px;
      border-radius: 50%;
      object-fit: cover;
    }
    .btn {
      color: $green !important;
      background: transparent;
      border: 0;

      svg {
        fill: $green;
      }
    }
  }
  .card-header {
    background-color: transparent;
    border: none;
    padding: 0;
    position: relative;
    z-index: 0;

    h5 {
      border-bottom: 1px solid #b3b3b3;
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin: 0;
      padding: 30px 0;
      margin: 0;
      transition: 0.1s all ease-in-out;
      transition-delay: 0.3s;

      &:after {
        background: $gradient1;
        display: block;
        content: "";
        -webkit-mask: url("~@/assets/images/svg/arrow-down-enrollment.svg")
          no-repeat 50% 50%;
        mask: url("~@/assets/images/svg/arrow-down-enrollment.svg") no-repeat
          50% 50%;
        -webkit-mask-size: cover;
        mask-size: cover;
        width: 23px;
        height: 14px;
        transition: all 0.15s;
        transform: rotate(0deg);
      }

      &.not-collapsed {
        border-bottom: 0;
        transition: 0.1s all ease-in-out;

        &:after {
          transform: rotate(180deg);
        }
      }
    }
  }

  .collapse {
    position: relative;
    z-index: 100;
  }

  .multiselect__input,
  .multiselect__single {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .add-brother {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    svg {
      font-size: 16px !important;
      position: relative;
      top: -1px;
    }
  }

  .delete-col {
    display: flex;
    align-items: center;
    justify-content: center;

    .icon-delete {
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      top: 5px;
      cursor: pointer;

      svg {
        font-size: 25px;
        color: $red;
      }
    }
  }
  .status-box {
    justify-content: flex-start;
    margin: 32px 0 16px;
    .status-style {
      margin: 0;
      button {
        width: 210px;
      }
    }
    .info {
      align-items: center;
      font-size: 16px;
      margin: 0 20px;
    }
  }

  .row-enrollment {
    padding-top: 0;
  }
}
</style>
